module.exports = __webpack_public_path__ + "img/not.a4ed1409.jpeg";